import { useEffect, useState } from 'react';
import { JoveLogoLoading } from '@jove-frontend/mui';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveCommonIframeView = function JoveCommonIframeView(props) {
  var className = props.className,
      url = props.url;

  var _useState = useState(''),
      realUrl = _useState[0],
      setRealUrl = _useState[1];

  var _useState2 = useState(true),
      loading = _useState2[0],
      setLoading = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    setRealUrl(url);
  }, [url]);
  /**
   * methods
   */

  var iframeLoadAction = function iframeLoadAction() {
    setLoading(false);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('relative flex flex-col', className),
    children: [loading && /*#__PURE__*/_jsx(JoveLogoLoading, {}), /*#__PURE__*/_jsx("iframe", {
      id: "widgetIframe",
      title: "Jove Insurance Quote",
      allowFullScreen: true,
      "allow-same-origin": "true",
      sandbox: "allow-scripts allow-same-origin allow-popups allow-forms",
      className: "scrolling-touch margin-0 padding-0 h-full w-full overflow-y-scroll border-0",
      src: realUrl,
      onLoad: iframeLoadAction
    }, realUrl)]
  });
};